import TopicflowIcon from "@components/topicflow-icon/topicflow-icon";
import { TopicflowIconType } from "@components/topicflow-icon/topicflow-icon-helpers";

const GetStartedCard = ({
  icon,
  title,
  body,
  onClick,
  disabled = false,
}: {
  icon: TopicflowIconType;
  title: string;
  body: string;
  onClick: () => void;
  disabled?: boolean;
}) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    className="flex-1 flex flex-col items-center text-center bg-white border border-gray-200 p-6 @4xl:p-9 rounded-[10px] hover:border-blue-400 hover:shadow-sm transition disabled:opacity-50 disabled:cursor-not-allowed"
  >
    <TopicflowIcon
      type={icon}
      className="w-6 h-6 @4xl:w-8 @4xl:h-8 text-blue-500 mb-4"
    />
    <div className="text-base font-medium text-gray-800 mb-1">{title}</div>
    <div className="tf-body-sm">{body}</div>
  </button>
);

export default GetStartedCard;
